import { render, staticRenderFns } from "./NavFade.vue?vue&type=template&id=820e40f2&scoped=true"
import script from "./NavFade.vue?vue&type=script&lang=js"
export * from "./NavFade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820e40f2",
  null
  
)

export default component.exports